import { render, staticRenderFns } from "./PanelLtda.vue?vue&type=template&id=39d1963a&scoped=true&"
import script from "./PanelLtda.vue?vue&type=script&lang=js&"
export * from "./PanelLtda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d1963a",
  null
  
)

export default component.exports